// extracted by mini-css-extract-plugin
var _1 = "AITextGenerationDraftPanel-moduleactions__k72Zp";
var _2 = "AITextGenerationDraftPanel-moduleaiNotice__vmTra";
var _3 = "AITextGenerationDraftPanel-modulecontent__Xrq26";
var _4 = "AITextGenerationDraftPanel-moduledivider__UNnG4 Divider-moduleDivider__dL3Vg";
var _5 = "AITextGenerationDraftPanel-moduleheader__ElTjH";
var _6 = "AITextGenerationDraftPanel-moduleleftActions__MCCP_";
var _7 = "AITextGenerationDraftPanel-modulepanel__GgZKH";
var _8 = "AITextGenerationDraftPanel-modulepanelError__bDWOR";
var _9 = "AITextGenerationDraftPanel-modulepromptPreview__lujm_";
var _a = "AITextGenerationDraftPanel-modulerightActions__kiWIE";
var _b = "AITextGenerationDraftPanel-modulesubjectPreview__yLRSF";
export { _1 as "actions", _2 as "aiNotice", _3 as "content", _4 as "divider", _5 as "header", _6 as "leftActions", _7 as "panel", _8 as "panelError", _9 as "promptPreview", _a as "rightActions", _b as "subjectPreview" }
